import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Tag, RefreshCw } from 'lucide-react';

export const InfluencerClientsTab = ({ clientCoupons, onRefresh }) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-xl font-bold text-slate-900">Atividades dos Clientes</h2>
      <Button size="sm" variant="outline" onClick={onRefresh} className="text-slate-600" data-testid="refresh-clients-btn">
        <RefreshCw className="h-4 w-4 mr-1" /> Atualizar
      </Button>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card className="bg-white border border-slate-200"><CardContent className="pt-5 text-center">
        <p className="text-3xl font-bold text-blue-600">{clientCoupons.length}</p>
        <p className="text-xs text-slate-500 mt-1">Cupons Ativos</p>
      </CardContent></Card>
      <Card className="bg-white border border-slate-200"><CardContent className="pt-5 text-center">
        <p className="text-3xl font-bold text-green-600">{clientCoupons.reduce((s, c) => s + (c.total_claims || 0), 0)}</p>
        <p className="text-xs text-slate-500 mt-1">Total de Resgates</p>
      </CardContent></Card>
      <Card className="bg-white border border-slate-200"><CardContent className="pt-5 text-center">
        <p className="text-3xl font-bold text-amber-600">{clientCoupons.reduce((s, c) => s + (c.current_uses || 0), 0)}</p>
        <p className="text-xs text-slate-500 mt-1">Cupons Usados</p>
      </CardContent></Card>
      <Card className="bg-white border border-slate-200"><CardContent className="pt-5 text-center">
        <p className="text-3xl font-bold text-purple-600">{new Set(clientCoupons.map(c => c.merchant_id)).size}</p>
        <p className="text-xs text-slate-500 mt-1">Lojistas Ativos</p>
      </CardContent></Card>
    </div>

    {clientCoupons.length > 0 ? (
      <Card className="bg-white border border-slate-200" data-testid="client-coupons-table">
        <CardHeader><CardTitle className="text-lg text-slate-900">Cupons dos Seus Clientes</CardTitle></CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-slate-200 text-xs text-slate-500">
                <th className="text-left py-2">Lojista</th>
                <th className="text-left">Cupom</th>
                <th className="text-center">Desconto</th>
                <th className="text-center">Usos</th>
                <th className="text-center">Resgates</th>
                <th className="text-center">Criado em</th>
                <th className="text-center">Validade</th>
              </tr></thead>
              <tbody>
                {clientCoupons.map(c => (
                  <tr key={c.coupon_id} className="border-b border-slate-50 hover:bg-slate-50">
                    <td className="py-2 text-slate-900 font-medium">{c.merchant_name}</td>
                    <td className="text-slate-700">{c.title}</td>
                    <td className="text-center"><Badge className="bg-red-50 text-red-600 border-red-200 text-xs">{c.discount_percentage}%</Badge></td>
                    <td className="text-center font-bold text-blue-600">{c.current_uses || 0}</td>
                    <td className="text-center font-bold text-green-600">{c.total_claims || 0}</td>
                    <td className="text-center text-xs text-slate-500">{c.created_at ? new Date(c.created_at).toLocaleDateString('pt-BR') : '-'}</td>
                    <td className="text-center text-xs text-slate-500">{c.expiry_date ? new Date(c.expiry_date).toLocaleDateString('pt-BR') : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    ) : (
      <Card className="bg-white border border-slate-200"><CardContent className="py-12 text-center">
        <Tag className="h-12 w-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500">Nenhum cupom ativo dos seus clientes ainda</p>
      </CardContent></Card>
    )}
  </div>
);
